import React from "react";

const Home = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h1 className="display-1">Home</h1>
        <p className="lead">This page is under development</p>
      </div>
    </div>
  );
};

export default Home;
